import { Component, OnInit, Input} from '@angular/core';
import { Optional } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { requiredModuleError } from '../../../shared/exceptions';
import { EnvironmentManager } from '../../../data-access/services/environment-manager.service';

@Component({
  selector: 'bm-auth-control-panel',
  templateUrl: './auth-control-panel.component.html',
  styleUrls: ['./auth-control-panel.component.scss']
})
export class AuthControlPanelComponent implements OnInit {

  currentUser: any;

  constructor(
    public env: EnvironmentManager,
    private auth: AuthService,
    @Optional() private router: Router) {

    if (!this.router) {
      requiredModuleError('Router');
    }
  }


  ngOnInit() {
    this.auth.currentUser.subscribe(user => {
      this.currentUser = user;
    });
  }

  logOut() {
    this.auth.logout()
    .then(() => this.router.navigate(['/', this.auth.authRoute]));
  }

}




